// 菜单配置服务（独立于权限系统）
import request from '../utils/request';

export interface MenuConfigItem {
  id: number;
  name: string;
  path: string;
  icon: string;
  parent: number | null;
  sort_order: number;
  is_active: boolean;
  description?: string;
  created_at: string;
  updated_at: string;
}

export interface RoleMenuConfigItem {
  id?: number;
  role: string;
  menu: number;
  is_visible: boolean;
  custom_name?: string;
  custom_path?: string;
  custom_icon?: string;
  sort_order?: number;
  created_at?: string;
  updated_at?: string;
}

class MenuConfigService {
  private baseURL = '/api/v1/menu-config';

  // 菜单项管理
  async getMenuItems(): Promise<MenuConfigItem[]> {
    // 聚合所有分页结果；兼容未分页返回
    let all: MenuConfigItem[] = [];
    let nextUrl: string | null = `${this.baseURL}/menu-items/`;
    while (nextUrl) {
      const response = await request.get(nextUrl);
      const data = response.data;
      if (data && typeof data === 'object' && 'results' in data) {
        all = all.concat(data.results || []);
        nextUrl = data.next;
      } else {
        // 未分页，直接返回
        return data;
      }
    }
    return all;
  }

  async getMenuTree(): Promise<any[]> {
    const response = await request.get(`${this.baseURL}/menu-items/tree/`);
    return response.data;
  }

  async createMenuItem(data: Partial<MenuConfigItem>): Promise<MenuConfigItem> {
    const response = await request.post(`${this.baseURL}/menu-items/`, data);
    return response.data;
  }

  async updateMenuItem(id: number, data: Partial<MenuConfigItem>): Promise<MenuConfigItem> {
    const response = await request.put(`${this.baseURL}/menu-items/${id}/`, data);
    return response.data;
  }

  async deleteMenuItem(id: number): Promise<void> {
    await request.delete(`${this.baseURL}/menu-items/${id}/`);
  }

  // 角色菜单配置
  async getRoleConfigs(role: string, subRole?: string): Promise<RoleMenuConfigItem[]> {
    const params = new URLSearchParams({ role });
    if (subRole) params.append('sub_role', subRole);
    const response = await request.get(`${this.baseURL}/role-configs/by_role/?${params}`);
    return response.data;
  }

  async batchUpdateRoleConfigs(role: string, subRole: string, configs: Array<{
    menu_id: number;
    is_visible: boolean;
    custom_name?: string;
    custom_name_en?: string;
    custom_path?: string;
    custom_icon?: string;
    sort_order?: number;
  }>): Promise<void> {
    await request.post(`${this.baseURL}/role-configs/batch_update/`, {
      role,
      sub_role: subRole,
      configs,
    });
  }

  // 用户菜单
  async getUserMenus(): Promise<any[]> {
    const response = await request.get(`${this.baseURL}/user-menus/my_menus/`);
    return response.data;
  }
}

export default new MenuConfigService();
